/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'file';
const prefix = `${moduleName}.${componentName}`;

export const noFileInputPlaceholder = `${prefix}.noFileInputPlaceholder`;
export const uploadFileLabel = `${prefix}.uploadFileLabel`;

export const ENGLISH = {
    [noFileInputPlaceholder]: 'No File Selected',
    [uploadFileLabel]: 'Upload File',
};
